import { render, staticRenderFns } from "./specConfig.vue?vue&type=template&id=4fa7e2ec&"
import script from "./specConfig.vue?vue&type=script&lang=js&"
export * from "./specConfig.vue?vue&type=script&lang=js&"
import style0 from "./specConfig.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports